/** Tasks and task boards. */
export default [

  {
    path: '/task-boards',
    name: 'Task Boards',
    component: () => import('@/views/private/TaskBoardsView.vue'),
    meta: {
      public: false,
      title: 'Task Boards',
    },
  },

  {
    path: '/task-board/:taskBoardId',
    name: 'Task Board',
    component: () => import('@/views/private/TaskBoardView.vue'),
    props: function(route) {
      return {
        taskBoardId: Number(route.params.taskBoardId),
      };
    },
    meta: {
      public: false,
      title: 'Task Board',
    },
  },

  {
    path: '/task-board-templates',
    name: 'Task Board Templates',
    component: () => import('@/views/private/TaskBoardTemplatesView.vue'),
    meta: {
      public: false,
      title: 'Task Board Templates',
    },
  },

  {
    path: '/tasks',
    name: 'Tasks',
    component: () => import('@/views/private/TasksView.vue'),
    meta: {
      public: false,
      title: 'Tasks',
    },
  },

  {
    path: '/task/:taskId',
    name: 'Task',
    component: () => import('@/views/private/TaskView.vue'),
    props: function(route) {
      return {
        taskId: Number(route.params.taskId),
      };
    },
    meta: {
      public: false,
      title: 'Task',
    },
  },

];
